
import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NavBar } from "./NavBar";
import { TabBar } from "./TabBar";
import { useAuth } from "../contexts/AuthContext";

interface AppLayoutProps {
  children: ReactNode;
  requireAuth?: boolean;
  showNavBar?: boolean;
}

export function AppLayout({ 
  children, 
  requireAuth = true, 
  showNavBar = true 
}: AppLayoutProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && requireAuth && !isAuthenticated) {
      navigate("/login", { state: { from: location.pathname } });
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname, requireAuth]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-16 h-16 border-4 border-househeld-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {isAuthenticated && showNavBar && <NavBar />}
      <div className={`container mx-auto p-4 ${isAuthenticated ? 'pt-20 pb-24' : ''}`}>
        {children}
      </div>
      {isAuthenticated && <TabBar />}
    </div>
  );
}
